<div class="logonav">
  <img src="{{logo}}" />
  <h3>{{welcomeText}}</h3>
</div>
